import "./plugins/extends";
import Vue from 'vue'
import router from "@/router";
import App from './App.vue'
import vuetify from './plugins/vuetify';
import {store} from '@/store';
import Vuelidate from "vuelidate";
import helper from './plugins/helper';
import {AxiosPlugin} from './plugins/axios'
import "./assets/css/style.css";
import 'jodit/build/jodit.min.css'
import JoditVue from 'jodit-vue'
import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"
import './scss/global.scss'

const toastOptions = {
    // Default bildirim ayarları
    transition: "Vue-Toastification__fade",
    position: 'top-right',
    timeout: 4000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: 'button',
    icon: true,
    // Custom icon kullanımı
    // icon: {
    //     iconClass: 'mdi mdi-eye',
    //     iconTag: 'span'
    // },
    maxToasts: 5
}

Vue.use(Toast, toastOptions);
Vue.use(JoditVue)
Vue.use(AxiosPlugin);
Vue.use(Vuelidate);
Vue.use(helper);

window.alert = function(text){
    store.commit("snackbar",text);
}
Vue.config.productionTip = false
store.commit("setRouter",router);
new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
